module.exports = __webpack_public_path__ + "media/images/writer/community/welcome@2x-ab1d63e8f497136821f312f5f619b9cd.png";